import React from 'react';
import { Loader, Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import formFieldType, { formFieldText } from '@/forms/helper';
import { states } from '@/constants/lifecycle';
import { firstError, firstErrorMessage } from '@/utils/errors';
import FormFieldList from '@/forms/components/FormFieldList';
import RequestSourceHeader from './RequestSourceHeader';
import fieldComponents from '../forms/fields';
import Events from '../hooks/events';

const RequestStepInfoContent = ({
  category,
  children,
  code,
  fields,
  hideSteps,
  name,
  request,
  readErrors,
  readStatus,
  saveErrors,
  saveStatus,
  section,
  sourceCode,
  sourceType,
}) => {
  const intl = useIntl();
  const updateProperties = Events.useUpdateRequestFields(category, { code });

  return (
    <div
      className={clsx('aridhia-request-step-info-content', hideSteps
        ? 'aridhia-wizard-content-no-steps' : 'aridhia-wizard-content')}
    >
      {name && (<RequestSourceHeader category={sourceType} code={sourceCode} name={name} />)}
      {firstError(readErrors) && (
        <Message
          className="modal-message"
          error
          size="small"
          icon="warning circle"
          key="errors"
          header={intl.formatMessage({ id: 'access.request.close.error' })}
          content={firstErrorMessage(readErrors)}
        />
      )}
      {children}
      {readStatus === states.PENDING && (<Loader active inline="centered" />)}
      {readStatus !== states.PENDING && (
        <FormFieldList
          canEdit
          category={category}
          code={code}
          component={(f) => fieldComponents[formFieldType(f)]}
          fields={fields}
          isEditing
          onChange={({ properties }) => updateProperties({ entity: section, properties })}
          saveErrors={saveErrors}
          saveStatus={saveStatus}
          section={section}
          text={(f) => formFieldText(request, f, 'fields.')}
        />
      )}
    </div>
  );
};

export default RequestStepInfoContent;
